module.exports = __webpack_public_path__ + "static/media/study220216.e05b4002.png";